import React from 'react';
import { FiArrowRight, FiZap } from 'react-icons/fi';
import './upgrade.css';

export default function NextStep({ children, action, onAction, secondary, className = '' }) {
  return <div className={`js-agent-next ${className}`}>
    <FiZap className="js-agent-next__icon" aria-hidden="true" />
    <div><p>{children}</p><div className="js-agent-next__actions"><button type="button" onClick={onAction}>{action}<FiArrowRight className="js-icon--directional" aria-hidden="true" /></button>{secondary}</div></div>
  </div>;
}
